import React, { FC, useState } from "react";

import { CloseIcon } from "../Icons";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { useDismissPrequalBanner } from "../../hooks/useDismissPrequalBanner";
import { usePrequalFunnel } from "../../hooks/usePrequalFunnel";
import { logPrequalEvent } from "../../shared/containers/PrequalificationContainer/prequalAnalytics";

// Prequalification entry banner (Figma 35816-43215). Succeeds the SGPD-406
// "Explore Plans" upsell in the dashboard card slot; the persistent gate is
// server-side via getAlerts.shouldShowPrequalification (SGPD-530), which is
// false when dismissed or when a valid prequalification already exists.
const PrequalDashboardCard: FC = () => {
  // Optimistic local hide so the banner disappears instantly on dismiss
  // without waiting for the next getAlerts refetch.
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const dismissPrequalBanner = useDismissPrequalBanner();
  const funnel = usePrequalFunnel({ source: "dashboard_banner" });

  const handleDismiss = () => {
    // `prequal_status_at_dismiss` is constant here by construction: the server
    // only sets shouldShowPrequalification (which gates this banner) when the
    // customer has no valid prequalification on file.
    logPrequalEvent(MIXPANEL_EVENTS.PREQUAL_BANNER_DISMISSED, {
      surface: "dashboard_card",
      prequal_status_at_dismiss: "none",
    });
    setIsVisible(false);
    dismissPrequalBanner();
  };

  if (!isVisible || !funnel.canEnter) {
    return null;
  }

  return (
    <div className="medium:py-6 medium:px-4 bg-[#95C6C5] p-4">
      <div className="rounded-xl bg-white p-4 flex flex-col gap-3 relative">
        <div className="flex gap-3 items-center">
          <img
            alt="prequalification_icon"
            className="w-20 h-20"
            src="/assets/icons/PrequalWellcare.svg"
          />
          <div className="flex flex-col justify-center gap-1">
            <div className="!text-base font-semibold">
              Your pet&apos;s full year of care starts here
            </div>
            <div className="!text-xs font-normal grow">
              See your TotalCare billing options in minutes
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <div
            className="text-xs text-center w-full bg-gv-yellow
            p-2 rounded-2xl font-semibold hover:bg-gv-yellow-dark cursor-pointer"
            onClick={funnel.start}
          >
            Check my eligibility
          </div>
        </div>
        <div className="absolute top-2 right-2 hover:bg-taupe-1 hover:rounded-full">
          <CloseIcon
            onClick={handleDismiss}
            className="text-light-black cursor-pointer"
          />
        </div>
      </div>
    </div>
  );
};

export default PrequalDashboardCard;
